<template>
  <!-- phone-flush: no telefone o painel vai de borda a borda, com o respiro dele (ver InstanceCard) -->
  <ontos-base v-bind="baseProps" ref="base" phone-flush>
    <!-- O MESMO painel de criar do modal, como a página de editar usa o do modal de editar: o
         cabeçalho, o card e o Salvar no rodapé. Esta página tinha um formulário próprio, com o
         cabeçalho solto e os botões numa linha à parte, e destoava da de editar (relato do
         usuário). Aqui ficaram só as decisões da página: de onde vêm os dados, o atalho para a
         lista, o "Salvar e criar outro" e para onde ir ao salvar. -->
    <ontos-instance-create v-if="loaded"
                           :context="$route.params"
                           :known="known"
                           :initial-values="draft"
                           :initial-name="initialName"
                           create-next autofocus
                           @saved="onSaved"
                           @showMessage="$emit('showMessage', $event)"
                           @showErrorMessage="$emit('showErrorMessage', $event)">
      <!-- Ir para a lista é controle da janela, fora do bloco das ações -->
      <template #controls>
        <ontos-header-action icon="mdi-view-list"
                             :label="$tt('instance-list', {'collection-plural': idea.pluralName})"
                             :to="{name: 'list-instances', params: $route.params}"/>
      </template>
    </ontos-instance-create>
  </ontos-base>
</template>
<script lang="ts">
import {Component, Prop, toNative} from 'vue-facing-decorator'
import IdeaLevelRouteComponent from "@/components/shared/IdeaLevelRouteComponent";
import InstanceCreate from "@/components/live/instance/InstanceCreate.vue";
import Instance from "@/types/Instance";
import {handOver, takeHandover} from "@/utils/handover";
import {createDraftKey, knownForCreate, readForCreate} from "@/utils/instanceCreation";
import {instanceViewKey} from "@/utils/instanceLink";
import {Preview} from "@/utils/instancePreview";

/** O que o Expandir do modal entrega: o rascunho e os candidatos que ele já tinha. */
type Handover = { instance: Instance, domains: Record<string, unknown>, reverseInfo: unknown }

@Component({
  components: {'ontos-instance-create': InstanceCreate}
})
class CreateInstance extends IdeaLevelRouteComponent {

  @Prop({}) readonly initialName!: string;

  given: Handover | null = null
  /** Tudo o que o painel leria — a coleção com o fluxo e os domínios, os candidatos e os reversos. */
  known: any = null

  /**
   * O rascunho e os candidatos — entregues pelo Expandir do modal, ou lidos aqui.
   *
   * Expandir não recomeça: o que foi digitado chega pela entrega, e com ele os candidatos que o
   * modal já tinha. Quem abre esta rota direto, por URL ou pelo "+" de outra tela, não encontra
   * entrega, e a página lê.
   *
   * A página, e não o painel, como a de editar: quem carrega é a rota, com a barra no alto como as
   * outras. O painel lendo sozinho mostrava o giro redondo das janelas (relato do usuário).
   */
  async load() {
    const {system, idea} = this.params as {system: string, idea: string}
    this.given = takeHandover(createDraftKey(this.params as any)) as Handover | null
    //Com a entrega, a coleção sai do ambiente, que já a tem com o fluxo e os domínios. Entrega sem
    //candidatos — a janela que não os recebeu de quem a abriu — conta como não ter: a página lê
    this.known = (this.given && knownForCreate(this.workspace, idea, this.given.domains, this.given.reverseInfo))
        || await readForCreate(this.$ideas, system, idea)
  }

  get draft(): Instance | undefined {
    return this.given ? this.given.instance : undefined
  }

  /** A ficha do item novo abre já com o que o rascunho tinha (ver `previewFromCreated`) e relê por trás. */
  onSaved(added: Instance, preview?: Preview) {
    const params = {...this.params, instance: String(added._instance)}
    if (preview) handOver(instanceViewKey(params as any), preview)
    this.$router.push({name: 'view-instance', params})
  }
}

export default toNative(CreateInstance)
</script>
